export default __webpack_public_path__ + "static/media/hotel4.cc1dcae9.jpg";